module.exports = __webpack_public_path__ + "static/img/icon_locate@2x.cac86be3.png";